<template>
    <div v-if="invitation"
         class="invitation-info-list text-primary"
         :width="width ? width : 'auto'">
        <h2 class="text-lonely mb-4">Данные приглашения</h2>

        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Заголовок:</div>
            <div class="text-lonely">{{invitation.title}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Сообщение:</div>
            <div class="text-lonely">{{invitation.message}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Отправитель:</div>
            <div class="text-lonely">{{invitation.senderName}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Дата создания:</div>
            <div class="text-lonely">{{getDate(invitation.dateTime)}}</div>
        </div>
        <div class="group-info d-flex flex-row text-h6">
            <div class="text-primary">Время создания:</div>
            <div class="text-lonely">{{getTime(invitation.dateTime)}}</div>
        </div>

        <h2 class="text-lonely my-4">Данные группы</h2>

        <GroupInfoList :group="invitation.group"
                       :width="width" />
    </div>
</template>

<script>
    import { DateTime } from "luxon";
    import GroupInfoList from "@/components/GroupInfoList.vue";

    export default {
        props: {
            invitation: Object,
            width: String
        },

        components: {
            GroupInfoList
        },

        computed: {
            currentLocale() {
                return this.$store.state.currentLocale;
            }
        },

        methods: {
            getDate(isoDateTime) {
                return DateTime.fromISO(isoDateTime).setLocale(this.currentLocale).toFormat("yyyy.MM.dd");
            },
            getTime(isoDateTime) {
                return DateTime.fromISO(isoDateTime).setLocale(this.currentLocale).toFormat("HH:mm");
            }
        }
    };
</script>

<style lang="scss">
    .invitation-info-list .group-info div.text-primary {
        min-width: 250px;
    }
</style>